import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dropdown,
  Menu,
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import clone from 'clone';
import { connect } from 'react-redux';
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import NavBar from '../../../components/NavBar';
import ProjectPanelBankers from '../../../components/ProjectPanelBankers';
import { editRoutes } from '../navigations';
import config from '../../../../config';

class PanelBankers extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    id: PropTypes.string,
    data: PropTypes.shape({
      loanTrackerProjectID: PropTypes.number,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    token: PropTypes.string,
    onCheck: PropTypes.func,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    auth: PropTypes.shape({
      company: PropTypes.object,
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const project = props.data;
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    return {
      loading,
      menuIsTab,
      project,
    };
  }
  constructor(props) {
    super(props);
    const state = PanelBankers.getPropsToState(props);
    this.state = {
      ...state,
      oriData: [],
      data: [],
      token: null,
      hasChanges: false,
      hasProjectChanges: false,
      hasBankerChanges: false,
    };
  }
  componentDidMount() {
    this.fetchProjectPanelBankers();
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = PanelBankers.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }

  setBankers = (oriData = []) => {
    return new Promise((res) => {
      this.setState({
        oriData,
        data: clone(oriData),
      }, () => {
        res(oriData);
      });
    });
  }
  setLoading = (loading = false) => {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  async fetchProjectPanelBankers() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/bankers/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const panelBankers = await res.json();
      await this.setBankers(panelBankers);
      await this.setComponentState({
        token,
      });
    }
    await this.setLoading(false);
  }
  async updateProject() {
    const { store } = this.context;
    const { project } = this.state;
    await this.setLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(project),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        await this.setLoading(false);
        return;
      }
      store.dispatch(flashErrorMessage(err));
    }
    const data = await res.json();
    await this.setComponentState({ hasChanges: false, hasProjectChanges: false }, () => {
      this.handleResetCheck();
    });
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: 'Update Success', message: `${data.name} successfully updated` }));
  }
  async updateProjectPanelBankers() {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/bankers/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(this.state.data),
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await this.setComponentState({ hasChanges: false, hasBankerChanges: false });
      this.handleOnCheck(false);
      await store.dispatch(flashSuccessMessage({ header: 'Update Success', message: 'Panel bankers successfully updated' }));
    }
    await this.setLoading(false);
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleOnChange = (data) => {
    this.setState({ data, hasChanges: true, hasBankerChanges: true }, () => {
      this.handleOnCheck(true);
    });
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  handleSetAutoAssignBankerStatus = (autoAssignStatus) => {
    const { project } = this.state;
    project.autoAssignBankerStatus = autoAssignStatus;
    this.setState({ project, hasChanges: true, hasProjectChanges: true });
  }
  handleCheckboxChange = (data) => {
    const { project } = this.state;
    if (data === 'preferred_banker' ||
    data === 'all') {
      let bankerSelectionTabs = [...project.bankerSelectionTabs];
      if (bankerSelectionTabs && bankerSelectionTabs.length > 0 && bankerSelectionTabs.includes(data)) {
        bankerSelectionTabs = bankerSelectionTabs.filter(option => option !== data);
      } else {
        bankerSelectionTabs.push(data);
      }
      project.bankerSelectionTabs = bankerSelectionTabs;
    }
    if (data === 'allowAgentSalesTeamBankerInvitation') {
      project.allowAgentSalesTeamBankerInvitation = !project.allowAgentSalesTeamBankerInvitation;
    }
    if (data === 'autoShareFormToBanker') {
      project.autoShareFormToBanker = !project.autoShareFormToBanker;
    }
    this.setState({ project, hasChanges: true, hasProjectChanges: true });
  }
  handleUpdate = (e) => {
    if (e) { e.preventDefault(); }
    const { hasBankerChanges, hasProjectChanges } = this.state;
    if (hasBankerChanges) {
      this.updateProjectPanelBankers();
    }
    if (hasProjectChanges) {
      this.updateProject();
    }
  }
  render() {
    const { auth, id, location } = this.props;
    const { pathname } = location;
    const { data, hasChanges, loading, project } = this.state;
    const companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const links = editRoutes(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, companyServiceID);
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                onClick={this.handleUpdate}
                disabled={loading || !hasChanges}
                positive
                content="Save"
              />
            </Menu.Item>
          }
        />
        <Dimmer style={{ zIndex: 20 }} active={loading} inverted>
          <Loader inline="centered">Loading</Loader>
        </Dimmer>
        <ProjectPanelBankers
          auth={this.props.auth}
          allowAgentSalesTeamBankerInvitation={project ? project.allowAgentSalesTeamBankerInvitation : false}
          autoShareFormToBanker={project ? project.autoShareFormToBanker : false}
          autoAssignStatus={project && project.autoAssignBankerStatus ? project.autoAssignBankerStatus : ''}
          bankerSelectionTabs={project && project.bankerSelectionTabs ? project.bankerSelectionTabs : []}
          data={data}
          defaultBookingStatusID={project ? project.defaultCustomBookingStatusID : ''}
          disabled={loading}
          token={this.props.token}
          projectID={this.props.id}
          onCheckboxChange={this.handleCheckboxChange}
          onChange={this.handleOnChange}
          onStatusChange={this.handleSetAutoAssignBankerStatus}
        />
      </Container>
    );
  }
}

export default connect(PanelBankers.mapStateToProps)(PanelBankers);



// WEBPACK FOOTER //
// ./src/containers/Project/PanelBankers/index.jsx